import moment from 'moment';
import React from 'react';
import { Badge, Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useInternalRequest } from './ContextAPI';

export default function ShowModel() {
    const { showModal, setShowModal, rowData } = useInternalRequest();
    // Closing the Model
    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <Modal className="modalWidth55" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Partner Internal Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Row>
                            <Col>
                                <Table bordered hover size="sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Partner Name</th>
                                            <th>Expected Receive Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{rowData?.partner_name}</td>
                                            <td>
                                                {rowData.expected_receive_date
                                                    ? moment(rowData.expected_receive_date).format(
                                                          'DD MMM YYYY'
                                                      )
                                                    : ''}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table bordered hover size="sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Req.Qty</th>
                                            <th>Apv.Qty</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    {rowData?.items?.map((el) => (
                                        <tbody key={Math.random()}>
                                            <tr>
                                                <td>{el.drug_name}</td>
                                                <td>{el.req_qty}</td>
                                                <td>{el.apv_qty}</td>
                                                <td>
                                                    {el.status === 'forwarded' ? (
                                                        <Badge className="badgeActive" bg="success">
                                                            Forwarded
                                                        </Badge>
                                                    ) : el.status === 'distributed' ? (
                                                        <Badge className="badgeActive" bg="success">
                                                            Distributed
                                                        </Badge>
                                                    ) : (
                                                        <Badge
                                                            className="badgeInactive"
                                                            bg="success"
                                                        >
                                                            Pending
                                                        </Badge>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </Table>
                            </Col>
                        </Row>
                    </Form.Group>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
